import { initializeFormalist } from "roneo/lib/formalist";

/**
 * Custom wrapper for Roneo’s `data-view-formalist` component
 * @param {Node} el
 * @param {Object} props DOM-originated props
 */
export default function newsletterFormalist(el, props) {
  const { form, render } = initializeFormalist(el, props);

  form.on("form:initialized", onFormInitialized);
  form.on("form:removed", onFormRemoved);

  // Render the form after binding events
  render();

  return {
    destroy: () => {
      form.off("form:initialized", onFormInitialized);
      form.off("form:removed", onFormRemoved);
    }
  };
}

const ITEMS_FORM_MATCHER = /sections.\d+.body:(?:item\b|items_list\b)/;
const ITEMS_LIST_SELECTOR_MATCHER = /items.(\d+).autofill_item_id/;
const AUTOFILL_SELECTOR_MATCHER = /autofill_item_id/;

function onFormInitialized({ namespace, form }) {
  // Bind to any items_list or item forms added to a section.x.body

  if (ITEMS_FORM_MATCHER.test(namespace)) {
    // Handle onchange for the selector_test field within
    form.on("field:change", onNestedFieldChange.bind(form));
  }
}

function onFormRemoved({ form }) {
  form.off("field:change", onNestedFieldChange);
}

function onNestedFieldChange({ namePath, value }) {
  const form = this;
  const isAutofill = AUTOFILL_SELECTOR_MATCHER.test(namePath);
  const listMatches = ITEMS_LIST_SELECTOR_MATCHER.exec(namePath);

  if (!(value && isAutofill)) {
    return;
  }

  // Default to single item form
  var itemFieldIdentifier = "";

  // If this is a list of items get the index
  if (listMatches && listMatches.length > 0) {
    const index = listMatches[1];
    itemFieldIdentifier = `items.${index}.`;
  }

  fetchData(value).then(data => {
    // Set data in same index
    form.setValue(`${itemFieldIdentifier}title`, data.title);
    form.setValue(`${itemFieldIdentifier}body`, data.description);
    form.setValue(`${itemFieldIdentifier}url`, data.url);
    form.setValue(`${itemFieldIdentifier}image.asset_id`, data.asset_id);
  });
}

function fetchData(id) {
  return new Promise((resolve, reject) => {
    window
      .fetch("/admin/search/items/" + id, {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        resolve(response.json());
      })
      .catch(error => {
        reject(error);
        console.log("Request failed: ", error);
      });
  });
}
